const IMAGE_METADATA_TYPES = new Set(["image", "logo", "asset", "chart", "screenshot"]);
const IMAGE_ID_PREFIX_PATTERN = /^(logo_|wikimedia_|deckimg_|chart_read_|format_read_|blueprint_|artifact_)/i;
const PRESENTATION_IMAGE_CONTEXT_PATTERN = /\|slide_[^|]+\|shape_[^|]+/i;
const isNonEmptyString = (value) => typeof value === "string" && value.trim().length > 0;
const isLikelyImageId = (value) => {
    if (!isNonEmptyString(value))
        return false;
    return IMAGE_ID_PREFIX_PATTERN.test(value) || PRESENTATION_IMAGE_CONTEXT_PATTERN.test(value);
};
const getMetadataType = (value) => {
    if (!value || typeof value !== "object")
        return null;
    const rawType = value.type;
    return isNonEmptyString(rawType) ? rawType.toLowerCase() : null;
};
const addId = (value, output) => {
    if (isNonEmptyString(value)) {
        output.add(value.trim());
    }
};
const addIds = (value, output) => {
    if (!Array.isArray(value))
        return;
    for (const item of value) {
        addId(item, output);
    }
};
export const extractToolResultImageIds = (result) => {
    const ids = new Set();
    const walk = (value) => {
        if (!value)
            return;
        if (Array.isArray(value)) {
            for (const item of value)
                walk(item);
            return;
        }
        if (typeof value !== "object")
            return;
        const record = value;
        addId(record._imageId, ids);
        addId(record.imageId, ids);
        addIds(record._imageIds, ids);
        addIds(record.imageIds, ids);
        if (Array.isArray(record.assets)) {
            for (const asset of record.assets) {
                if (!asset || typeof asset !== "object")
                    continue;
                const assetRecord = asset;
                const metadataType = getMetadataType(assetRecord.metadata);
                if (metadataType && IMAGE_METADATA_TYPES.has(metadataType)) {
                    addId(assetRecord.assetId, ids);
                }
                else if (isLikelyImageId(assetRecord.assetId)) {
                    addId(assetRecord.assetId, ids);
                }
            }
        }
        const metadataType = getMetadataType(record.metadata);
        if (metadataType && IMAGE_METADATA_TYPES.has(metadataType)) {
            addId(record.assetId, ids);
        }
        else if (isLikelyImageId(record.assetId)) {
            addId(record.assetId, ids);
        }
    };
    walk(result);
    return Array.from(ids);
};
export const resolveToolResultImagePreviews = async (imageIds) => {
    if (imageIds.length === 0 || typeof window.__getContextImageData !== "function") {
        return [];
    }
    const resolved = await Promise.all(imageIds.map(async (imageId) => {
        try {
            const payload = (await window.__getContextImageData?.(imageId));
            if (!payload?.base64)
                return null;
            const mimeType = payload.mimeType || "image/png";
            const src = payload.base64.startsWith("data:image/")
                ? payload.base64
                : `data:${mimeType};base64,${payload.base64}`;
            return { id: imageId, src };
        }
        catch {
            return null;
        }
    }));
    return resolved.filter((preview) => preview !== null);
};
